import Vue from "vue";
import Router from "vue-router";
import MainAppComponent from "@/components/main/main-app";
import MainPaywall from "../components/main/paywall/paywall";
import ProAgencyDataTransfer from "../components/main/pro-agency-data-transfer/pro-agency-data-transfer";
import Questionnaire from "../components/main/questionnaire/questionnaire";
import BookingRequest from "../components/main/booking-request/booking-request";
import PaymentFail from "../components/main/payment-fail/payment-fail";
import SharedLogin from "../components/main/shared-login/shared-login";
import B2BAppComponent from "@/components/b2b/b2b-app";
import RedirectComponent from "../components/redirect";
import HomeComponent from "../components/home";
import LoginComponent from "@/components/login";
import SignupComponent from "@/components/sign-up";
import B2BLoginComponent from "@/components/b2b/b2b-login";
import b2bRouter from "../modules/b2b/router/index";
import bookingRouter from "../modules/booking/router/router";
import accountingRouter from "../modules/accounting/router";
import distributionRouter from "../modules/distribution/router";
import catalogRouter from "../modules/catalog/router";
import royaltyRouter from "../modules/royalty/router";
import licenceRouter from "../modules/licensing/router";
import taskRouter from "../modules/tasks/router";
import settingsModuleRouter from "../modules/settings/router";
import { contactsModuleRouter } from "../modules/contacts/router";
import { gptModuleRouter } from "../modules/to-be-deleted/router";
import { RouteGuard, InitMainRoute, initOutMainComponentRoute } from "./guard";
import { InitB2bRoute } from "../modules/b2b/router/route";
import { PlaygroundRouter } from "../playground/router";
Vue.use(Router);

console.log(catalogRouter, bookingRouter);

const AppRouter = new Router({
  // mode: 'history',
  routes: [
    {
      path: "/",
      name: "root",
      redirect: "main/home"
    },
    {
      path: "/signup",
      name: "signup",
      component: SignupComponent
    },
    {
      path: "/main/paywall",
      name: "mainpaywall",
      beforeEnter: initOutMainComponentRoute,
      component: MainPaywall
    },
    {
      path: "/main/pro-agency-data-transfer",
      name: "pro-agency-data-transfer",
      component: ProAgencyDataTransfer
    },
    {
      path: "/main/questionnaire",
      name: "questionnaire",
      component: Questionnaire
    },
    
    {
      path: "/main/request",
      name: "request",
      component: BookingRequest
    },
    {
      path: "/main/payment-fail",
      name: "payment-fail",
      component: PaymentFail,
      beforeEnter: initOutMainComponentRoute,
    },
    {
      path: "/main/shared-login",
      name: "shared-login",
      component: LoginComponent,
      beforeEnter: initOutMainComponentRoute,
    },
    ...gptModuleRouter,
    {
      path: "/main",
      name: "main",
      component: MainAppComponent,
      redirect: "main/home",
      beforeEnter: InitMainRoute,
      children: [
        {
          path: "/main/redirect",
          name: "redirect",
          component: RedirectComponent
        },
        {
          path: "/main/home",
          name: "home",
          component: HomeComponent
        },
        ...accountingRouter,
        ...bookingRouter,
        ...contactsModuleRouter,
        ...settingsModuleRouter,
        ...distributionRouter,
        ...catalogRouter,
        ...royaltyRouter,
        ...licenceRouter,
        ...taskRouter,
        {
          path: "*",
          redirect: "/main/home"
        }
      ]
    },
    {
      path: "/b2b",
      name: "b2b",
      component: B2BAppComponent,
      redirect: "/b2b/home",
      beforeEnter: InitB2bRoute,
      children: [...b2bRouter]
    },
   
    {
      path: "/main/login",
      name: "mainLogin",
      component: LoginComponent
    },
   
    {
      path: "/b2b/login",
      name: "b2bLogin",
      component: B2BLoginComponent
    },

    PlaygroundRouter
  ]
});

AppRouter.beforeResolve(RouteGuard);

export default AppRouter;

window.AppRouter = AppRouter;
